window.dotchDeliveryInfo = {
  flagsUrl: null,
  cachedData: null,

  init: function(flagsUrl) {
    this.flagsUrl = flagsUrl;
    this.update();
    document.addEventListener('DOMContentLoaded', () => this.update());
    document.addEventListener('cart-drawer:refreshed', () => this.update());
  },

  fetch: function() {
    if (this.cachedData) return Promise.resolve(this.cachedData);
    return fetch(this.flagsUrl)
      .then(res => res.json())
      .then(data => { this.cachedData = data; return data; });
  },

  update: function() {
  this.fetch().then(data => {
    var code = window.visitorCountry || 'default';
    var country = data[code];
    var defaultCountry = data['default'];

    document.querySelectorAll('.delivery-info').forEach(function(el) {
      var isShort = el.dataset.short === 'true';

      if (country && country.short && code !== 'default') {
        if (isShort) {
          el.innerHTML = 'Delivered to <img src="' + country.flag + '" style="width:16px;margin:0 2px;vertical-align:middle;"> in ' + country.days + ' days';
        } else {
          el.innerHTML = 'Delivered to&nbsp;' + country.short +
            '&nbsp;<img src="' + country.flag + '" style="width:20px;margin-right:4px;vertical-align:middle;">' +
            'in&nbsp;' + country.days + ' business days';
        }
      } else {
        el.innerHTML = isShort ? 'Delivered in 6 days' : defaultCountry.default_time;
      }
    });
  });
}
};